<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div class="d-flex justify--space-between">
          <h1>Наши магазины</h1>
          <va-button color="info" @click="visibilityModalLocation">
            Добавить
          </va-button>
        </div>
      </va-card>
      <locations-table :locations="locations">
        <template #tablename><h1 class="mb-3">Филиалы</h1></template>
      </locations-table>
    </va-inner-loading>
    <va-modal v-model="show" size="large" hide-default-actions>
      <location-create @hide="visibilityModalLocation"></location-create>
    </va-modal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import LocationCreate from "../../components/locations/location-create.vue";
import locationsTable from "../../components/locations/locations-table.vue";
import { yandexMap, ymapMarker } from "vue-yandex-maps";

export default {
  components: {
    locationsTable,
    LocationCreate,
    yandexMap,
    ymapMarker,
  },
  data() {
    return {
      show: false,
      yandexMapCoords: [55.00262456968209, 73.386825], // Омск [latitude, longitude] для API 2.1
      yandexMapAddress: "",
      yandexMapSearchQuery: "",
    };
  },
  methods: {
    ...mapActions({
      fetchLocations: "locations/getLocations",
    }),
    visibilityModalLocation() {
      this.show = !this.show;
    },
    async searchYandexMapAddress() {
      if (!this.yandexMapSearchQuery) {
        return;
      }

      try {
        // Используем HTTP API геокодера напрямую, чтобы избежать ошибок
        const apiKey = "8f61b621-e389-4848-af4a-60fa20c8eb9c";
        const response = await fetch(
          `https://geocode-maps.yandex.ru/1.x/?apikey=${apiKey}&geocode=${encodeURIComponent(
            this.yandexMapSearchQuery
          )}&format=json&results=1`
        );

        if (!response.ok) {
          throw new Error("Ошибка при запросе к геокодеру");
        }

        const data = await response.json();

        if (
          data.response &&
          data.response.GeoObjectCollection &&
          data.response.GeoObjectCollection.featureMember.length > 0
        ) {
          const geoObject =
            data.response.GeoObjectCollection.featureMember[0].GeoObject;
          const pos = geoObject.Point.pos.split(" ").map(Number);
          // API возвращает [latitude, longitude], нужно для API 2.1
          this.yandexMapCoords = [pos[0], pos[1]];
          this.yandexMapAddress =
            geoObject.metaDataProperty.GeocoderMetaData.text;
          this.yandexMapSearchQuery = "";
        } else {
          alert("Адрес не найден");
        }
      } catch (error) {
        console.error("Ошибка поиска адреса:", error);
        alert("Ошибка при поиске адреса. Попробуйте еще раз.");
      }
    },
    async onYandexMapClick(e) {
      if (!window.ymaps) {
        return;
      }
      const coords = e.get("coords");
      this.yandexMapCoords = coords;

      // Используем HTTP API геокодера напрямую, чтобы избежать ошибок с двойным слешем
      try {
        const apiKey = "8f61b621-e389-4848-af4a-60fa20c8eb9c";
        const [lat, lon] = coords;
        const response = await fetch(
          `https://geocode-maps.yandex.ru/1.x/?apikey=${apiKey}&geocode=${lon},${lat}&format=json&results=1`
        );

        if (!response.ok) {
          throw new Error("Ошибка при запросе к геокодеру");
        }

        const data = await response.json();

        if (
          data.response &&
          data.response.GeoObjectCollection &&
          data.response.GeoObjectCollection.featureMember.length > 0
        ) {
          const geoObject =
            data.response.GeoObjectCollection.featureMember[0].GeoObject;
          this.yandexMapAddress =
            geoObject.metaDataProperty.GeocoderMetaData.text;
        } else {
          this.yandexMapAddress = "Адрес не определен";
        }
      } catch (error) {
        console.error("Ошибка обратного геокодирования:", error);
        // Fallback на встроенный геокодер, если HTTP API не работает
        try {
          const myGeocoder = window.ymaps.geocode(coords);
          myGeocoder.then((res) => {
            const firstGeoObject = res.geoObjects.get(0);
            if (firstGeoObject) {
              this.yandexMapAddress = firstGeoObject.properties.get("text");
            }
          });
        } catch (fallbackError) {
          console.error("Ошибка fallback геокодирования:", fallbackError);
          this.yandexMapAddress = "Адрес не определен";
        }
      }
    },
  },
  computed: {
    ...mapState("locations", ["locations"]),
    ...mapGetters({
      loader: "isLoading",
    }),
  },
  async created() {
    await this.fetchLocations();
  },
};
</script>

<style scoped></style>
